module.exports = __webpack_public_path__ + "media/images/favicons/ms-icon-310x310-0dde83792f79046115381070a1d96495.png";